module.exports = __webpack_public_path__ + "img/wei1.e1469576.png";